// Bind assistant operations to the same list state and service calls as the page.
function useInvoiceListControl(state) {
  const latest = useRef(state); latest.current = state;
  const businessId = window.PlummeBackend.activeBusinessId;
  useEffect(() => window.PlummeInvoiceListLiveControl.register({
    businessId, year: state.year,
    read: () => { const s = latest.current; return { rows: s.list, tab: s.tab, search: s.search, selectedIds: [...s.selectedIds], paymentAccounts: s.paymentAccounts, expanded: s.exp, filter: s.filter }; },
    search: (tab, query, archived) => { const s = latest.current; s.setTab(tab); s.setSearch(query); s.setFilter({ ...makeInvoiceListFilter(), checks: { __arkiv: archived } }); s.setSelectedIds(new Set()); s.setExp(null); },
    select: (ids) => latest.current.setSelectedIds(new Set(ids)),
    expand: (id) => latest.current.setExp(id),
    openDraft: (draft) => window.PlummeBackend.setOpenInvoice(invoiceListOpenDraftPayload(draft)),
    prepareAction: async (operation, ids, options) => {
      const s = latest.current;
      if (operation === 'reminder') { window.__plummeInvoiceListBulkIntent={operation,options:options||{}};s.setBulkAction('reminder'); return true; }
      if (operation === 'issue_draft') { s.setBulkAction('issue'); return true; }
      if (operation === 'delete_draft') { s.setBulkAction('delete'); return true; }
      if (ids.length === 1 && ['send', 'credit', 'register_payment', 'refund', 'edit_payment', 'reverse_payment', 'settle_without_payment'].includes(operation)) {
        s.setExp(ids[0]);
        window.__plummeInvoiceListNativeIntent = { id: ids[0], operation, options: options || {} };
        window.setTimeout(() => window.dispatchEvent(new CustomEvent('plumme-invoice-list-native-intent')), 0);
        return true;
      }
      if (operation === 'send') { window.__plummeInvoiceListBulkIntent={operation,options:options||{}};s.setBulkAction('send'); return true; }
      if (operation === 'credit') { window.__plummeInvoiceListBulkIntent={operation,options:options||{}};s.setBulkAction('credit'); return true; }
      return false;
    },
    closePreparedAction: () => {
      latest.current.setBulkAction(null);
      window.dispatchEvent(new CustomEvent('plumme-invoice-list-native-intent', { detail: { action: 'close' } }));
    },
  }), [businessId, state.year]);
}

Object.assign(globalThis, { useInvoiceListControl });
